import script from "./ZAccordionPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./ZAccordionPanel.vue?vue&type=script&setup=true&lang=js"

import "./ZAccordionPanel.vue?vue&type=style&index=0&id=1111327b&lang=scss"

const __exports__ = script;

export default __exports__